module.exports = __webpack_public_path__ + "img/fourday_ps_15.e266adea.jpg";